import { WithStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel, { InputLabelProps } from '@material-ui/core/InputLabel';
import Select, { SelectProps } from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';

const styles = (theme: Theme) =>
	createStyles({
		cssFocused: {},
		cssLabel: {
			'&$cssFocused': {
				color: `${theme.palette.primary.light}} !important`,
			},
			color: theme.palette.primary.light,
		},
		cssUnderline: {
			'&:after': {
				borderBottomColor: theme.palette.primary.light,
			},
			'&:before': {
				borderBottomColor: theme.palette.primary.light,
			},
			'&:hover:not($disabled):not($focused):not($error):before': {
				borderBottomColor: `${theme.palette.primary.main} !important`,
			},
		},
		formControl: {
			minWidth: 200,
		},
	});

type Props = { label: string } & SelectProps & WithStyles<typeof styles>;

/**
 * ユーザ情報Selectフォーム
 * @param myProps
 */
const ProfileFormSelect: React.FC<Props> = myProps => {
	const selectProps = { ...myProps };
	const inputLabelProps = {} as InputLabelProps;
	const classes = myProps.classes;

	if (selectProps.id) {
		inputLabelProps.htmlFor = selectProps.id;
	}

	if (!selectProps.disabled) {
		// 編集用ラベルプロパティ
		inputLabelProps.className = classes.cssLabel;
	}

	return (
		<FormControl className={classes.formControl}>
			<InputLabel {...inputLabelProps}>{myProps.label}</InputLabel>
			<Select {...selectProps} />
		</FormControl>
	);
};

export default withStyles(styles)(ProfileFormSelect);



// WEBPACK FOOTER //
// ./src/components/ProfileFormSelect.tsx